// extracted by mini-css-extract-plugin
export default {"root":"styles_root__qFXwN","label":"styles_label__UFwGk"};